import React, { useState } from "react";
import * as Constants from "../../constants/urls";

const Permission=(props)=>{
    return(
        <> 
        <div className="text-center" style={{width:"100%",height:"100vh",background:"#00bac6",display:"flex",alignItems:"center"}}>
<div className="container">
<h1 className="text-center text-white  w-100">403</h1>

<h5 className="text-center text-white w-100 mb-5">شما دسترسی به این صفحه ندارید</h5>
<div className="text-center text-white w-100">
    <a  className="btn btn-dark" href={Constants.siteUrl}>بازگشت به سایت</a>
</div>
             </div>
             
            </div>

         </>
    )
}
export default Permission;